// extracted by mini-css-extract-plugin
export default {"preview":"styles-module__preview__src-labstep-web-core-Action-Preview-_X6sjE","label":"styles-module__label__src-labstep-web-core-Action-Preview-__AUvz"};